import { CurrentJackpotValue } from "../models/JackpotCurValue";
import { JackpotHitData } from "../models/JackpotHitData";
import { ParametersMessage } from "../models/Messages";

const CommonEvents = {
  UPDATED_CONFIG: "UPDATED_CONFIG",
  UPDATED_GAME_INFO: "UPDATED_GAME_INFO",
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  CHANGE_THEME: "CHANGE_THEME",
  WEB_SOCKET_TIMEOUT: "WEB_SOCKET_TIMEOUT",
  WEB_SOCKET_CONNECTION_OK: "WEB_SOCKET_CONNECTION_OK",
} as const;

type CommonEventMap = {
  [CommonEvents.UPDATED_CONFIG]: [];
  [CommonEvents.UPDATED_GAME_INFO]: [];
  [CommonEvents.CHANGE_LANGUAGE]: [lang: string];
  [CommonEvents.CHANGE_THEME]: [theme: string];
};

const MessageEvents = {
  MESSAGE_PARAMETERS: "MESSAGE_PARAMETERS",
  MESSAGE_PROGRESSIVE_CUR_VALUES: "MESSAGE_PROGRESSIVE_CUR_VALUES",
  MESSAGE_JACKPOT_HIT: "MESSAGE_JACKPOT_HIT",
  MESSAGE_JACKPOT_HISTORY: "MESSAGE_JACKPOT_HISTORY",
  MESSAGE_CONNECTION_OK: "MESSAGE_CONNECTION_OK",
  MESSAGE_CONNECTION_WARN: "MESSAGE_CONNECTION_WARN",
  MESSAGE_CONNECTION_ERROR: "MESSAGE_CONNECTION_ERROR",
};

type MessageEventMap = {
  [MessageEvents.MESSAGE_PARAMETERS]: [msg: ParametersMessage];
  [MessageEvents.MESSAGE_JACKPOT_HIT]: [hit: JackpotHitData];
  [MessageEvents.MESSAGE_JACKPOT_HISTORY]: [newHistory: JackpotHitData[]];
  [MessageEvents.MESSAGE_PROGRESSIVE_CUR_VALUES]: [
    curValues: CurrentJackpotValue[],
  ];
  [MessageEvents.MESSAGE_CONNECTION_OK]: [];
  [MessageEvents.MESSAGE_CONNECTION_WARN]: [];
  [MessageEvents.MESSAGE_CONNECTION_ERROR]: [];
};

const GameEvents = {
  JACKPOT_CUR_VALUES_UPDATED: "JACKPOT_CUR_VALUES_UPDATED",
  JACKPOT_HISTORY_UPDATED: "JACKPOT_HISTORY_UPDATED",
  JACKPOT_HIT: "JACKPOT_HIT",
};

type GameEventMap = {
  [GameEvents.JACKPOT_HISTORY_UPDATED]: [];
  [GameEvents.JACKPOT_HISTORY_UPDATED]: [];
  [GameEvents.JACKPOT_HIT]: [hit: JackpotHitData];
};

export {
  CommonEvents,
  type CommonEventMap,
  MessageEvents,
  type MessageEventMap,
  GameEvents,
  type GameEventMap,
};
